
import React, {FC, useEffect, useRef} from 'react';
import classNames from 'classnames';
import {DateSlot} from 'components/TimePicker/types';
import moment from 'moment-timezone';

import * as styles from './styles.module.scss';

type EntryProps = {
	slot: DateSlot
	selected: boolean
	full: boolean
	scroll?: boolean
	onSelect: () => void
};

const Entry: FC<EntryProps> = ({slot, selected, full, scroll, onSelect}) => {
	const ref = useRef<HTMLDivElement>(null);
	const className = classNames({
		[styles.entry]: true,
		[styles.selected]: selected,
		[styles.full]: full,
	});

	useEffect(() => {
		if (selected && scroll && ref.current) {
			ref.current.scrollIntoView({
				// behavior: 'smooth',
				block: 'nearest',
				inline: 'center',
			});
		}
	}, [selected, scroll, ref.current]);

	return (
		<div className={className} ref={ref} onClick={onSelect}>
			{moment(slot.date).format('ddd MMM DD')}
		</div>
	);
};

export default Entry;
